import {
  WonBidUploadSlot,
  type HeldDocument,
} from "@/components/bond-submission/WonBidUploadSlot";
import {
  FINAL_CONTRACT_ACCEPT,
  FINAL_CONTRACT_MAX_BYTES,
} from "@/lib/brokerBonds";

// BRK-S421 step 4, "Award letter" — the award letter or the executed
// contract, through the final-contract route (`uploadBondFinalContract`);
// its pointer is the won body's `awardLetterDocumentId`, so finishing waits
// on it.

export function WonBidAwardStep({
  held,
  uploading,
  error,
  onFile,
}: {
  held: HeldDocument | null;
  uploading: boolean;
  error?: string;
  onFile: (file: File) => void;
}) {
  return (
    <>
      <p className="text-sm text-brk-dim">
        Required. The award letter or the signed contract, as a PDF.
      </p>
      <WonBidUploadSlot
        inputLabel="Upload the award letter or contract"
        prompt="Drag & drop the award letter or contract, or"
        hint={`PDF only, up to ${String(FINAL_CONTRACT_MAX_BYTES / (1024 * 1024))} MB.`}
        accept={FINAL_CONTRACT_ACCEPT}
        held={held}
        uploading={uploading}
        error={error}
        onFile={onFile}
      />
    </>
  );
}
